<template >
  <div >
    <q-fab
        :label="
                selectedBookings && selectedBookings.length
                  ? selectedBookings.length
                  : null
              "
        style="float: right"
        color="secondary"
        push
        icon="build"
        direction="down"
        v-if="workingKind != 'PACKAGE'"
        square >
      <q-fab-action
          color="primary"
          @click="moveMode = !moveMode"
          square
          external-label
          icon="open_with"
          :label="
                  moveMode ? 'Dont move bookings' : '!Move selected bookings'
                "
          label-position="left" />
      <q-fab-action
          square
          external-label

          label="Issue Invoices/API"
          label-position="left"
          color="accent"
          @click="issueDialog()"
          icon="receipt" />

      <q-fab-action
          square
          external-label
          label="Excel"
          label-position="left"
          color="accent"
          @click="getExcel()"
          icon="insert_chart" />
      <q-fab-action
          square
          v-if="workingKind != 'EXCRS'||userDomain == 'travel'"
          external-label
          label="calc prices"
          label-position="left"
          color="accent"
          @click="calcPrices()"
          icon="functions" />
      <q-fab-action
          square
          v-if="workingKind != 'EXCRS' && userDomain == 'travel2'"
          external-label
          label="update SunWeb"
          label-position="left"
          color="accent"
          @click="updateSunWeb()"
          icon="send" />
    </q-fab >
  </div >
</template >

<script >
export default {
  props: {
    rQuery: {
      type: Object,
      default: () => {
      }
    },
    newRowData: {
      type: Object,
      default: () => null
    },
    wakeUpPath: {
      type: String,
      default: null
    },
    sortingProp: {
      type: [String,
             Boolean],
      default: null
    },
    lazyLoader: {
      type: Boolean,
      default: true
    },
    simpleLazyLoader: {
      type: Boolean,
      default: false
    },
    addEmptyLine: {
      type: Boolean,
      default: false
    },

    selectedBookings: {
      type: Array,
      default: () => []
    },
    workingKind: {
      type: String,
      default: null
    },
  },
  name: "BookingsHelpers",
  computed: {
    moveMode: {
      get() {
        return !!this.$route.query.moveMode
      },
      set(v) {
        if (v === true)
          this.routeGo({query: {moveMode: true}})
        else this.routeGo({query: {moveMode: null}})
      }
    }
  }
}
</script >

<style scoped >

</style >
